import React from "react";

import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import Modal, { ModalType } from "..";
import { Color } from "../../../Form/Button";
import useStyles from "./styles";

interface Props {
  open: boolean;
  onClose?: (isConfirmed: boolean) => void;
}

const Leave = (props: Props) => {
  const { open, onClose } = props;

  const { t: translate } = useTranslation();

  const classes = useStyles();

  return (
    <Modal
      open={open}
      className={classes.modal}
      handleClose={() => onClose && onClose(false)}
      title={translate("leaveWithoutSave")}
      showActionButtons
      type={ModalType.LEAVE}
      data-cy="corfirmLeaveModal"
      actionButtonProps={{
        onCancel: () => onClose && onClose(false),
        onSave: () => onClose && onClose(true),
        customColorSave: Color.WARNING,
        customColorCancel: Color.TEXT_INFO,
        textSave: translate("leave"),
        dataCySave: "modalLeaveButton",
        dataCyCancel: "modalLeaveCancel",
      }}
    >
      <Stack width="100%" direction="column" spacing={1}>
        <Typography
          fontFamily="Inter"
          fontWeight={400}
          fontSize="16px"
          lineHeight="24px"
          color="#232325"
        >
          {translate("youHaveUnsavedChangesAreYouSureYouWantToLeave")}
        </Typography>
        <Typography
          fontStyle="italic"
          fontFamily="Inter"
          fontWeight={400}
          fontSize="16px"
          lineHeight="24px"
          color="#F79009"
        >
          {translate("youShouldSaveYourWorkBeforeLeaving")}
        </Typography>
      </Stack>
    </Modal>
  );
};

export default Leave;
